import {
// @ts-expect-error - react-dnd@3 has no types
DropTarget } from 'react-dnd';
import { memo } from 'react';
import { reorderingItemType } from '../../constants';
import { useReorderingContext } from '../../core/ReorderingContext';
import { requestAnimationFrameThrottle } from '../../core/utils/requestAnimationFrameThrottle';
import { createHoverHandler } from '../../core/utils/createHoverHandler';
import { jsx as _jsx } from "react/jsx-runtime";
export const withItemDropTarget = Wrapped => {
  // Instance variables for tracking state - will be shared across all columns
  // but that's OK because only one can be hovered at a time
  let currentElement = null;
  const hoverState = {
    lastProcessedPosition: null,
    lastMousePosition: null,
    dragDirection: null
  };

  // Create throttled hover handler
  const throttledHoverHandler = requestAnimationFrameThrottle((props, mousePosition) => {
    const hoverHandler = createHoverHandler({
      updateDragState: props.reordering.updateDragState,
      getFromIndex: () => props.reordering.fromIndex,
      getCurrentToIndex: () => props.reordering.toIndex,
      getOrientation: () => props.reordering.orientation,
      getElement: () => currentElement,
      hoveredIndex: props.columnIndex
    }, hoverState);
    hoverHandler(mousePosition);
  });
  const dropSpec = {
    hover: (props, monitor) => {
      if (!monitor.isOver({
        shallow: true
      })) {
        return;
      }
      const clientOffset = monitor.getClientOffset();
      if (clientOffset) {
        throttledHoverHandler(props, {
          x: clientOffset.x,
          y: clientOffset.y
        });
      }
    },
    drop: props => {
      // Reset state on drop
      hoverState.lastProcessedPosition = null;
      hoverState.lastMousePosition = null;
      hoverState.dragDirection = null;
      currentElement = null;
      props.reordering.handleDrop();
    }
  };
  const collectDrop = connect => {
    // Wrap connectDropTarget to capture element reference
    const originalConnect = connect.dropTarget();
    const connectDropTarget = element => {
      currentElement = element;
      return originalConnect(element);
    };
    return {
      connectDropTarget: connectDropTarget
    };
  };
  const DropTargetComponent = DropTarget(reorderingItemType, dropSpec, collectDrop)(Wrapped);
  return /*#__PURE__*/memo(props => {
    const reordering = useReorderingContext();
    return /*#__PURE__*/_jsx(DropTargetComponent, Object.assign({}, props, {
      reordering: reordering
    }));
  });
};